
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { BookingItemProps } from ".";
import { loading, find } from "store/booking";

interface ApiBookingFindByIdInputProps {
    id: number;
}

type ApiBookingFindOutputProps = OutputBaseProps<{ item: BookingItemProps; }, ApiBookingFindByIdInputProps>;

export const apiBookingFindById = async (data: ApiBookingFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiBookingFindOutputProps>(`/api/booking/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};